import { useState } from 'react';

function findGetParameter(parameterName: string) {
  var result = null,
    tmp = [];
  window.location.search
    .substr(1)
    .split('&')
    .forEach(function(item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

export default function useCustomAuth(setErr: any) {
  const [user, setUser] = useState<{
    displayName: string;
    photoURL: string;
    roomName: string;
    isAdmin: boolean;
    participants: string[];
    isMod: boolean;
    isRomRec: boolean;
    isMuted: boolean;
    timeLeft: string;
  } | null>(null);
  const [ran, setRan] = useState(false);

  useState(() => {
    if (findGetParameter('m') === '' || ran) return;
    setRan(true);
    fetch(process.env.REACT_APP_TOKEN_ENDPOINT + `/api/client?m=${findGetParameter('m')}`, {})
      .then(async res => {
        if (res.ok) {
          return res;
        }
        const json = await res.json();
        const errorMessage = json.error?.message || res.statusText;
        throw Error(errorMessage);
      })
      .then(res => res.json())
      .then(res => {
        if (res.displayName != null) {
          setUser({
            displayName: res.displayName,
            photoURL: res.photoURL,
            isAdmin: res.isAdmin,
            isMod: res.isMod,
            isRomRec: res.isRomRec,
            isMuted: res.isMuted,
            roomName: res.roomName,
            timeLeft: res.timeLeft,
            participants: res.participants,
          });
        } else {
          let msg = res;
          if (res === 'invalid token') {
            msg = 'Lejárt a belépési jegyed. Csatlakoz újra a felületről!';
          } else if (res === 'end' || res === 'closed') {
            msg = 'A megbeszélés lejárt!';
          } else if (res === 'access error') {
            msg = 'Hozzáférési hiba, csatlakoz újra a felületről!';
          }
          setErr({
            message: msg,
          });
        }
      });
  });

  return { user };
}
